// Textos del módulo Carta (menu.tsx y api/menu.ts). Ver src/i18n/textos.ts.
import { defineTextos } from '../textos.ts';

export const textosCarta = defineTextos({
  // --- lista ---
  titulo: 'Carta',
  errorCargandoCarta: 'Error cargando la carta',
  enSede: ' en {sede}',
  disponibleMin: 'disponible',
  agotadoMin: 'agotado',
  errorPrefijo: 'Error: ',
  platoCreado: 'Plato creado: {nombre}',
  cambiosGuardados: 'Cambios guardados',
  marcadoAgotado: '{nombre} marcado como agotado',
  statPlatos: 'Platos',
  statDisponibles: 'Disponibles',
  statAgotados: 'Agotados',
  statCategorias: 'Categorías',
  nuevoPlato: 'Nuevo plato',
  buscarPlatoCodigo: 'Buscar plato o código…',
  todos: 'Todos',
  filtrarDisponibilidad: 'Filtrar por disponibilidad',
  categoria: 'Categoría',
  ordenPrecio: 'Precio',
  categoriasMayus: 'CATEGORÍAS',
  todas: 'Todas',
  cargandoCarta: 'Cargando carta…',
  sinResultados: 'Sin resultados',
  probaOtraBusqueda: 'Probá con otra búsqueda o categoría.',
  platoConReceta: 'Plato con receta',
  recetaChip: 'receta',
  sinDescripcion: 'Sin descripción',
  marcarAgotado: 'Marcar agotado',
  marcarDisponible: 'Marcar disponible',
  disponible: 'Disponible',
  agotado: 'Agotado',
  seleccionaPlato: 'Selecciona un plato',
  tocaCualquierPlato: 'Toca cualquier plato para ver y editar su ficha, o crea uno nuevo.',

  // --- ficha del plato ---
  aunReducida: 'Aun reducida pesa {kb} KB. Probá con una foto más chica.',
  noSeProcesoImagen: 'No se pudo procesar la imagen.',
  cambiosSinGuardar: 'Tenés cambios sin guardar',
  salirNuevo: 'Si salís ahora, el plato no se crea y se pierde lo que cargaste.',
  salirEditar: 'Si salís ahora se pierden los cambios que hiciste en este plato.',
  salirSinGuardar: 'Salir sin guardar',
  nombreObligatorio: 'El nombre es obligatorio',
  precioMayorCero: 'El precio debe ser mayor a 0',
  elaboradoSinIngrediente: 'Un plato elaborado debe tener al menos un ingrediente',
  eligeMateriaPrima: 'Elegí la materia prima que se descuenta del inventario al vender este ítem',
  sencilloUnaMateria: 'Un ítem sencillo descuenta una sola materia prima: dejá solo una (o pasalo a elaborado)',
  fotoNoSubio: 'El plato se guardó, pero la foto no se pudo subir.',
  fotoNoAsignada: 'El plato se guardó, pero no se pudo asignar la foto.',
  sugNoGuardadas: 'no se pudieron guardar las sugerencias',
  platoGuardadoSugNo: 'El plato se guardó, pero las sugerencias no: {aviso}',
  noSeGuardoPlato: 'No se pudo guardar el plato',
  secDatos: 'Datos del plato',
  secPrecio: 'Precio y carta',
  secReceta: 'Receta',
  secInventario: 'Inventario',
  secPersonalizacion: 'Personalización',
  secSugerencias: 'Sugerencias',
  volverCarta: 'Volver a la carta',
  sinNombre: 'Sin nombre',
  codAutogenerado: 'CÓD. AUTOGENERADO',
  sinGuardar: 'Sin guardar',
  faltanCampos: 'Faltan campos obligatorios',
  guardando: 'Guardando…',
  crearPlato: 'Crear plato',
  guardar: 'Guardar',
  soloGerentes: 'Solo gerentes pueden editar la ficha. Sí podés cambiar la disponibilidad desde la lista.',
  duplicar: 'Duplicar',
  confirmAgotarTitulo: '¿Marcar "{nombre}" como agotado?',
  confirmAgotarMsg: 'El plato deja de estar disponible en la carta hasta que lo reactivés.',
  agotar: 'Agotar',
  nombreDelPlato: 'Nombre del plato',
  ejGyros: 'Ej: Gyros de cerdo',
  catAlimentos: '🍽️ Alimentos',
  catBebidas: '🥤 Bebidas',
  catOtros: '✨ Otros',
  tipoDePlato: 'Tipo de plato',
  tipoSencillo: '🥤 Sencillo',
  tipoElaborado: '🍽️ Elaborado (con receta)',
  ayudaSencillo: 'Se vende tal cual (gaseosa, agua, postre envasado): cada venta descuenta UNA materia prima del inventario, que elegís en la pestaña Inventario. No se puede personalizar.',
  ayudaElaborado: 'Con receta — los ingredientes se descuentan al vender, y podés habilitar exclusiones y adiciones.',
  descripcion: 'Descripción',
  describePlato: 'Describe el plato…',
  descripcionEn: 'Descripción en inglés (tienda web)',
  describePlatoEn: 'Ej: Greek yogurt, cucumber and dill…',
  ayudaDescripcionEn: 'La tienda en inglés muestra este texto debajo del nombre del plato. Vacío: muestra la descripción en español.',
  precioVentaPublico: 'Precio de venta al público',
  precioIncluyeInc: 'Este es el precio que paga el cliente — el INC ya está incluido.',
  baseGravable: 'Base gravable',
  disponibleEnCarta: 'Disponible en carta',
  meserosPuedenAgregar: 'Los meseros pueden agregarlo a un pedido',
  disponibilidadEnCarta: 'Disponibilidad en carta',
  impuestosEImagen: 'Impuestos e imagen',
  incIncluido: 'INC % (incluido en el precio)',
  fotoDelPlato: 'Foto del plato',
  fotoAyuda: 'Se muestra en el POS al agregar el plato al pedido. Se reduce automáticamente; el máximo que acepta el servidor es {max} KB.',
  sinFoto: 'Sin foto',
  subiendo: 'Subiendo…',
  cambiarFoto: 'Cambiar foto',
  elegirGaleria: 'Elegir de la galería',
  quitarFoto: 'Quitar foto',
  fotoSeAsigna: 'La foto se asigna al guardar el plato.',
  fotoSeSube: 'La foto se sube al guardar el plato.',
  ingredientesTitulo: 'Ingredientes',
  materiaPrimaDescuenta: 'Materia prima que se descuenta',
  ingrediente: 'ingrediente',
  ingredientes: 'ingredientes',
  vinculada: 'vinculada',
  sinVincular: 'sin vincular',
  ayudaRecetaElaborado: 'Se descuentan del inventario cada vez que se vende el plato.',
  ayudaRecetaSencillo: 'Cada venta baja esta cantidad de la materia prima (una gaseosa = 1 und de esa gaseosa). Sin esto, el stock no se mueve.',
  quitarNombre: 'Quitar {nombre}',
  buscarMateriaSubreceta: 'Buscar materia prima o subreceta…',
  buscarMateriaInventario: 'Buscar materia prima del inventario…',
  cargandoInventario: 'Cargando inventario…',
  ningunIngrediente: 'Ningún ingrediente coincide.',
  todosIngredientesAgregados: 'Todos los ingredientes ya fueron agregados.',
  quePuedePedir: 'Qué puede pedir el cliente',
  personalizacionAyuda: '"La hamburguesa sin cebolla", "con carne extra". Todo arranca bloqueado a propósito: prometerle al cliente que se puede sacar un ingrediente que ya viene mezclado en una salsa es peor que no ofrecerlo.',
  agregaIngredientesA: 'Agregá ingredientes en la sección',
  agregaIngredientesB: 'y acá vas a poder decidir cuáles se pueden quitar y cuáles se cobran como adición.',
  porPlato: 'por plato',
  sePuedePedirSin: 'Se puede pedir sin {ingrediente}',
  adicionExtra: 'Adición extra',
  noSeOfrece: 'no se ofrece',
  alAdicionarla: 'Al adicionarla se descuentan {cantidad} {unidad} más del inventario.',
  sugeriConEste: 'Sugerí con este plato',
  sugerenciasAyuda: 'Al agregar este plato a un pedido, el mesero ve estos como sugerencia para ofrecerle al cliente. Opcional.',
  buscarNombreCodigoCat: 'Buscar por nombre, código o categoría…',
  limpiarBusqueda: 'Limpiar búsqueda',
  cartaCompleta: 'Carta completa',
  plato: 'plato',
  platos: 'platos',
  cargandoLaCarta: 'Cargando la carta…',
  ningunPlatoCoincide: 'Ningún plato coincide con "{q}".',
  yaAgregasteTodos: 'Ya agregaste todos los platos de la carta como sugerencia.',

  // --- api/menu.ts (reducirImagenPlato) ---
  navegadorNoProcesa: 'El navegador no pudo procesar la imagen.',
  noSeLeyoImagen: 'No se pudo leer la imagen.',
}, {
  // --- list ---
  titulo: 'Menu',
  errorCargandoCarta: 'Error loading the menu',
  enSede: ' at {sede}',
  disponibleMin: 'available',
  agotadoMin: 'sold out',
  errorPrefijo: 'Error: ',
  platoCreado: 'Dish created: {nombre}',
  cambiosGuardados: 'Changes saved',
  marcadoAgotado: '{nombre} marked as sold out',
  statPlatos: 'Dishes',
  statDisponibles: 'Available',
  statAgotados: 'Sold out',
  statCategorias: 'Categories',
  nuevoPlato: 'New dish',
  buscarPlatoCodigo: 'Search dish or code…',
  todos: 'All',
  filtrarDisponibilidad: 'Filter by availability',
  categoria: 'Category',
  ordenPrecio: 'Price',
  categoriasMayus: 'CATEGORIES',
  todas: 'All',
  cargandoCarta: 'Loading menu…',
  sinResultados: 'No results',
  probaOtraBusqueda: 'Try another search or category.',
  platoConReceta: 'Dish with recipe',
  recetaChip: 'recipe',
  sinDescripcion: 'No description',
  marcarAgotado: 'Mark sold out',
  marcarDisponible: 'Mark available',
  disponible: 'Available',
  agotado: 'Sold out',
  seleccionaPlato: 'Select a dish',
  tocaCualquierPlato: 'Tap any dish to view and edit its details, or create a new one.',

  // --- dish details ---
  aunReducida: 'Even reduced, it weighs {kb} KB. Try a smaller photo.',
  noSeProcesoImagen: 'Could not process the image.',
  cambiosSinGuardar: 'You have unsaved changes',
  salirNuevo: 'If you leave now, the dish is not created and what you entered is lost.',
  salirEditar: 'If you leave now, the changes you made to this dish are lost.',
  salirSinGuardar: 'Leave without saving',
  nombreObligatorio: 'The name is required',
  precioMayorCero: 'The price must be greater than 0',
  elaboradoSinIngrediente: 'A prepared dish must have at least one ingredient',
  eligeMateriaPrima: 'Choose the raw material deducted from inventory when this item is sold',
  sencilloUnaMateria: 'A simple item deducts a single raw material: keep only one (or switch it to prepared)',
  fotoNoSubio: 'The dish was saved, but the photo could not be uploaded.',
  fotoNoAsignada: 'The dish was saved, but the photo could not be assigned.',
  sugNoGuardadas: 'the suggestions could not be saved',
  platoGuardadoSugNo: 'The dish was saved, but the suggestions were not: {aviso}',
  noSeGuardoPlato: 'Could not save the dish',
  secDatos: 'Dish details',
  secPrecio: 'Price & menu',
  secReceta: 'Recipe',
  secInventario: 'Inventory',
  secPersonalizacion: 'Customization',
  secSugerencias: 'Suggestions',
  volverCarta: 'Back to the menu',
  sinNombre: 'Untitled',
  codAutogenerado: 'AUTO-GENERATED CODE',
  sinGuardar: 'Unsaved',
  faltanCampos: 'Required fields are missing',
  guardando: 'Saving…',
  crearPlato: 'Create dish',
  guardar: 'Save',
  soloGerentes: 'Only managers can edit the dish details. You can still change availability from the list.',
  duplicar: 'Duplicate',
  confirmAgotarTitulo: 'Mark "{nombre}" as sold out?',
  confirmAgotarMsg: 'The dish is no longer available on the menu until you reactivate it.',
  agotar: 'Mark sold out',
  nombreDelPlato: 'Dish name',
  ejGyros: 'E.g.: Pork gyros',
  catAlimentos: '🍽️ Food',
  catBebidas: '🥤 Drinks',
  catOtros: '✨ Other',
  tipoDePlato: 'Dish type',
  tipoSencillo: '🥤 Simple',
  tipoElaborado: '🍽️ Prepared (with recipe)',
  ayudaSencillo: 'Sold as is (soda, water, packaged dessert): each sale deducts ONE raw material from inventory, which you choose in the Inventory tab. It cannot be customized.',
  ayudaElaborado: 'With recipe: ingredients are deducted when sold, and you can enable removals and add-ons.',
  descripcion: 'Description',
  describePlato: 'Describe the dish…',
  descripcionEn: 'English description (online store)',
  describePlatoEn: 'e.g. Greek yogurt, cucumber and dill…',
  ayudaDescripcionEn: 'The store in English shows this text under the dish name. Empty: it shows the Spanish description.',
  precioVentaPublico: 'Retail price',
  precioIncluyeInc: 'This is the price the customer pays; INC is already included.',
  baseGravable: 'Taxable base',
  disponibleEnCarta: 'Available on the menu',
  meserosPuedenAgregar: 'Waiters can add it to an order',
  disponibilidadEnCarta: 'Menu availability',
  impuestosEImagen: 'Taxes & image',
  incIncluido: 'INC % (included in the price)',
  fotoDelPlato: 'Dish photo',
  fotoAyuda: 'Shown in the POS when the dish is added to an order. It is reduced automatically; the server accepts up to {max} KB.',
  sinFoto: 'No photo',
  subiendo: 'Uploading…',
  cambiarFoto: 'Change photo',
  elegirGaleria: 'Choose from gallery',
  quitarFoto: 'Remove photo',
  fotoSeAsigna: 'The photo is assigned when you save the dish.',
  fotoSeSube: 'The photo is uploaded when you save the dish.',
  ingredientesTitulo: 'Ingredients',
  materiaPrimaDescuenta: 'Raw material deducted',
  ingrediente: 'ingredient',
  ingredientes: 'ingredients',
  vinculada: 'linked',
  sinVincular: 'not linked',
  ayudaRecetaElaborado: 'They are deducted from inventory every time the dish is sold.',
  ayudaRecetaSencillo: 'Each sale deducts this amount of the raw material (one soda = 1 unit of that soda). Without this, stock does not move.',
  quitarNombre: 'Remove {nombre}',
  buscarMateriaSubreceta: 'Search raw material or sub-recipe…',
  buscarMateriaInventario: 'Search raw material in inventory…',
  cargandoInventario: 'Loading inventory…',
  ningunIngrediente: 'No ingredient matches.',
  todosIngredientesAgregados: 'All ingredients have already been added.',
  quePuedePedir: 'What the customer can ask for',
  personalizacionAyuda: '"The burger without onion", "with extra meat". Everything starts locked on purpose: promising the customer that an ingredient already mixed into a sauce can be removed is worse than not offering it.',
  agregaIngredientesA: 'Add ingredients in the',
  agregaIngredientesB: 'section and here you can decide which ones can be removed and which are charged as add-ons.',
  porPlato: 'per dish',
  sePuedePedirSin: 'Can be ordered without {ingrediente}',
  adicionExtra: 'Extra add-on',
  noSeOfrece: 'not offered',
  alAdicionarla: 'When added, {cantidad} {unidad} more is deducted from inventory.',
  sugeriConEste: 'Suggest with this dish',
  sugerenciasAyuda: 'When this dish is added to an order, the waiter sees these as suggestions to offer the customer. Optional.',
  buscarNombreCodigoCat: 'Search by name, code or category…',
  limpiarBusqueda: 'Clear search',
  cartaCompleta: 'Full menu',
  plato: 'dish',
  platos: 'dishes',
  cargandoLaCarta: 'Loading the menu…',
  ningunPlatoCoincide: 'No dish matches "{q}".',
  yaAgregasteTodos: 'You already added every dish on the menu as a suggestion.',

  // --- api/menu.ts (reducirImagenPlato) ---
  navegadorNoProcesa: 'The browser could not process the image.',
  noSeLeyoImagen: 'Could not read the image.',
});
